import { useLang } from "@/context/LanguageContext";
import { Target, Wallet, Shuffle, Recycle, Clock } from "lucide-react";

const ICONS = { nutrition: Target, budget: Wallet, variety: Shuffle, reuse: Recycle, time: Clock };
const TONE = {
  excellent: "good", good: "good", respected: "good", optimized: "good", adapted: "good",
  fair: "warn", slightly_over: "warn", partial: "warn", not_set: "muted",
  over: "bad", low: "bad", long: "bad",
};
const TONE_CLS = {
  good: "bg-chenia-sage/30 text-foreground",
  warn: "bg-chenia-rosesoft text-chenia-terracottadark",
  bad: "bg-destructive/10 text-destructive",
  muted: "bg-secondary text-muted-foreground",
};

export function QualitySummary({ plan, memberId }) {
  const { t } = useLang();
  const q = plan.quality || {};
  const w = plan.weekly || {};
  const avg = w.avg_by_member?.[memberId];

  return (
    <div className="chenia-card p-5 sm:p-6" data-testid="plan-weekly-summary">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-lg font-semibold">{t("weekly_summary")}</h2>
        <span className="text-xs text-muted-foreground">{w.distinct_recipes} {t("distinct_recipes")} · {t("reuse_rate")} {Math.round((w.reuse_rate || 0) * 100)}%</span>
      </div>

      <div className="mt-4 grid grid-cols-2 sm:grid-cols-5 gap-2">
        {Object.entries(q).map(([k, v]) => {
          const Icon = ICONS[k];
          return (
            <div key={k} className={`rounded-2xl px-3 py-2.5 ${TONE_CLS[TONE[v] || "muted"]}`} data-testid={`quality-${k}`}>
              <div className="flex items-center gap-1.5 text-xs opacity-80"><Icon className="h-3.5 w-3.5" /> {t(`q_${k}`)}</div>
              <p className="mt-0.5 text-sm font-semibold leading-tight">{t(`q_${v}`)}</p>
            </div>
          );
        })}
      </div>

      {avg && (
        <div className="mt-4 rounded-2xl bg-secondary/60 p-4" data-testid="weekly-avg">
          <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">{t("week_avg")} · {t("planned")} / {t("target")}</p>
          <div className="mt-2 grid grid-cols-4 gap-2 text-center">
            {["calories", "protein", "carbs", "fat"].map((k) => (
              <div key={k}>
                <p className="font-semibold text-sm">{avg.planned[k]}<span className="text-muted-foreground font-normal"> / {avg.target[k]}</span></p>
                <p className="text-[11px] text-muted-foreground">{t(k)} {k === "calories" ? "" : "(g)"}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
